import React from 'react';
import { CartoonPortrait } from './CartoonPortrait';
interface FigureProps {
  className?: string;
}
export function OnlyChildFigure({
  className = ''
}: FigureProps) {
  return <CartoonPortrait className={className} label="Cartoon portrait of an independent, self-assured only child" disc="#0D6B57" skin="#E3B08C" skinShade="#CE9A76" hair="#1B1B1B" shirt="#FBF7F0" hairStyle="shortCrop" mouth="smirk" motif="ring" data-id="element-71" data-mp="3bpmygam09hjv" />;
}